/**
 * Can be used for ENV and ESS dates score
 * @param score from 0 to MAX (real case is from 0 to 10)
 * @returns A B C D E ''
 */
export function getScoreLetterFromScoreVenueDates(score: number): string {
  if (score >= 8) {
    return 'A';
  } else if (score >= 6) {
    return 'B';
  } else if (score >= 4) {
    return 'C';
  } else if (score >= 2) {
    return 'D';
  } else if (score >= 0) {
    return 'E';
  } else {
    return '';
  }
}
